import { FlippableGridData } from "../types/grid-item";

export const IceCream2023: FlippableGridData = {
  id: 1,
  title: "Ice Cream 2023",
  gridItems: [
    [
      {
        front: { title: "1" },
        back: { title: "Cotton Candy", image_src: "cotton-candy.png" },
      },
      {
        front: { title: "2" },
        back: { title: "Purple Velvet", image_src: "purple-velvet.png" },
      },
      {
        front: { title: "3" },
        back: { title: "Kettle Corn", image_src: "kettlecorn.png" },
      },
      {
        front: { title: "4" },
        back: {
          title: "Sticky Toffee Pudding",
          image_src: "sticky-toffee-pudding.png",
        },
      },
      {
        front: { title: "5" },
        back: {
          title: "PB Fudge Pretzel",
          image_src: "pb-fudge-pretzel.png",
        },
      },
    ],
    [
      {
        front: { title: "6" },
        back: {
          title: "Chocolate PB",
          image_src: "chocolate-pb.png",
        },
      },
      {
        front: { title: "7" },
        back: { title: "Lemon", image_src: "lemon.png" },
      },
      {
        front: { title: "8" },
        back: { title: "Milkshake & Fries", image_src: "milkshake-fries.png" },
      },
      {
        front: { title: "9" },
        back: { title: "Apple Pie", image_src: "apple-pie.png" },
      },
      {
        front: { title: "10" },
        back: {
          title: "Honey Cornbread & Jam",
          image_src: "honey-cornbread-jam.png",
        },
      },
    ],
    [
      {
        front: { title: "11" },
        back: {
          title: "Cranberry Crumble",
          image_src: "cranberry-crumble.png",
        },
      },
      {
        front: { title: "12" },
        back: { title: "Mac & Cheese", image_src: "mac-n-cheese.png" },
      },
      {
        front: { title: "13" },
        back: { title: "Pickle", image_src: "pickle.png" },
      },
      {
        front: { title: "14" },
        back: { title: "Fudge Brownie", image_src: "fudge-brownie.png" },
      },
      {
        front: { title: "15" },
        back: { title: "Vanilla Bean", image_src: "vanilla-bean.png" },
      },
    ],
  ],
};

export const IceCream2024: FlippableGridData = {
  id: 2,
  title: "Ice Cream 2024",
  gridItems: [
    [
      {
        front: { title: "1" },
        back: { title: "Cookie Butter", image_src: "cookie-butter.png" },
      },
      {
        front: { title: "2" },
        back: {
          title: "Black Cherry Chip",
          image_src: "black-cherry-chip.png",
        },
      },
      {
        front: { title: "3" },
        back: {
          title: "Salted Choco. Truffle",
          image_src: "salted-chocolate-truffle.png",
        },
      },
      {
        front: { title: "4" },
        back: { title: "Thai Iced Tea", image_src: "thai-iced-tea.png" },
      },
      {
        front: { title: "5" },
        back: { title: "King Alphonso", image_src: "alphonso-mango.png" },
      },
    ],
    [
      {
        front: { title: "6" },
        back: { title: "Strawberry", image_src: "strawberry.png" },
      },
      {
        front: { title: "7" },
        back: {
          title: "PB Brownie Honeycomb",
          image_src: "peanutbutter-brownie-honeycomb.png",
        },
      },
      {
        front: { title: "8" },
        back: { title: "Malai", image_src: "buffalo-milk.png" },
      },
      {
        front: { title: "9" },
        back: {
          title: "Praline Butter Cake",
          image_src: "praline-butter-cake.png",
        },
      },
      {
        front: { title: "10" },
        back: { title: "Red Velvet", image_src: "red-velvet.png" },
      },
    ],
    [
      {
        front: { title: "11" },
        back: { title: "Coffee Affogato", image_src: "coffee-affogato.png" },
      },
      {
        front: { title: "12" },
        back: { title: "Pickle", image_src: "pickle.png" },
      },
      {
        front: { title: "13" },
        back: { title: "Apple Cinnamon", image_src: "apple-cinn.png" },
      },
      {
        front: { title: "14" },
        back: { title: "Butterscotch", image_src: "butterscotch.png" },
      },
      {
        front: { title: "15" },
        back: { title: "Rajbhog", image_src: "honey-cardamom-saffron.png" },
      },
    ],
  ],
};

export const USStates2025: FlippableGridData = {
  id: 2,
  title: "US States 2025",
  gridItems: [
    [
      {
        front: { title: "1" },
        back: { title: "Georgia", image_src: "" },
      },
      {
        front: { title: "2" },
        back: { title: "Texas", image_src: "" },
      },
      {
        front: { title: "3" },
        back: { title: "Florida", image_src: "" },
      },
      {
        front: { title: "4" },
        back: { title: "Nevada", image_src: "" },
      },
      {
        front: { title: "5" },
        back: { title: "Ilinois", image_src: "" },
      },
    ],
    [
      {
        front: { title: "6" },
        back: { title: "Nebraska", image_src: "" },
      },
      {
        front: { title: "7" },
        back: { title: "Minnesota", image_src: "" },
      },
      {
        front: { title: "8" },
        back: { title: "Louisiana", image_src: "" },
      },
      {
        front: { title: "9" },
        back: { title: "Idaho", image_src: "" },
      },
      {
        front: { title: "10" },
        back: { title: "California", image_src: "" },
      },
    ],
    [
      {
        front: { title: "11" },
        back: { title: "Missouri", image_src: "" },
      },
      {
        front: { title: "12" },
        back: { title: "Kentucky", image_src: "" },
      },
      {
        front: { title: "13" },
        back: { title: "Montanna", image_src: "" },
      },
      {
        front: { title: "14" },
        back: { title: "Tennessee", image_src: "" },
      },
      {
        front: { title: "15" },
        back: { title: "Oklahoma", image_src: "" },
      },
    ],
  ],
};

export const Games: FlippableGridData[] = [IceCream2023, IceCream2024, USStates2025];

export enum TwoTeamGuessingTeams {
  RED = "RED",
  BLUE = "BLUE",
}
